import TabsNew from './views/TabsNew.c';
export default TabsNew;
